// extracted by mini-css-extract-plugin
export var deliveryRow = "_nj-a";
export var fixedHeight = "_nj-4";
export var freightLogo = "_nj-9";
export var fullWidth = "_nj-3";
export var priceColumn = "_nj-5";
export var radioSelected = "_nj-7";
export var radioUnselected = "_nj-6";
export var selectedOption = "_nj-2";
export var selectedOptionContainer = "_nj-1";
export var selection = "_nj-0";
export var tallSkeletonText = "_nj-8";